import { configureStore } from '@reduxjs/toolkit';
import apiSlice from '../hooks/apiSlice';
import settingsSlice  from '../hooks/settingsSlice';
import sidebarSlice from './sidebarSlice';

export const store = configureStore({
  reducer: {
    api:apiSlice,
    settings: settingsSlice,
    sidebar: sidebarSlice
  },
});
